import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row q-col-gutter-md"
}
const _hoisted_2 = { class: "col-12 col-sm-4 flex flex-center column" }
const _hoisted_3 = { class: "text-caption text-center q-mt-sm text-grey-6" }
const _hoisted_4 = { class: "col-12 col-sm-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle1 q-mb-sm" }, "Select a Person", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_PersonSelect = _resolveComponent("PersonSelect")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_AsyncBtn = _resolveComponent("AsyncBtn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Assign Face to Person",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_q_btn, {
        flat: "",
        "no-caps": "",
        icon: "fa fa-plus",
        label: "New Person",
        color: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleCreate()))
      }),
      _createVNode(_component_q_space),
      _createVNode(_component_q_btn, {
        flat: "",
        label: "Cancel",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hide()))
      }),
      _createVNode(_component_AsyncBtn, {
        label: "Assign",
        color: "primary",
        task: _ctx.task,
        disabled: !_ctx.selectedPersonId,
        onClick: _ctx.assign
      }, null, 8, ["task", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.face)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.face.imageUrl)
                ? (_openBlock(), _createBlock(_component_q_img, {
                    key: 0,
                    src: _ctx.face.imageUrl,
                    ratio: 1,
                    fit: "cover",
                    class: "rounded-borders",
                    style: {"width":"140px","height":"140px"}
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_q_icon, {
                    key: 1,
                    name: "fa fa-user-circle",
                    size: "120px",
                    color: "grey-5"
                  })),
              _createElementVNode("div", _hoisted_3, _toDisplayString(Math.round(_ctx.face.confidence)) + "% confidence ", 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_PersonSelect, {
                ref: "personSelect",
                "client-id": _ctx.clientId,
                "model-value": _ctx.selectedPersonId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedPersonId = $event)),
                onCreated: _ctx.onPersonCreated
              }, null, 8, ["client-id", "model-value", "onCreated"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}